import React, { PropsWithChildren } from 'react';
import { Card, Flex, Heading, Text, TextButton } from '@amzn/storm-ui';
import { Trans, useTranslation } from 'react-i18next';

const Refresh = ({ children }: PropsWithChildren) => {
  return <TextButton onClick={() => window.location.reload()}>{children}</TextButton>;
};

export interface ErrorCardProps {
  title?: string;
  message?: string;
}

export const ErrorCard = ({ title, message }: ErrorCardProps) => {
  const { t: translate } = useTranslation();

  return (
    <Card padding='large'>
      <Flex direction='column' alignItems='center'>
        <Heading renderAs='h2'>{title || translate('sspa_rcm_ad_reports_generic_error', 'Sorry, something went wrong')}</Heading>
        <Text withMargin>
          {message ? (
            message
          ) : (
            <Trans
              t={translate}
              i18nKey={'sspa_rcm_ad_reports_please_refresh'}
              defaults={'<TButton>Refresh page</TButton> to try again'}
              components={{
                TButton: <Refresh />
              }}
            />
          )}
        </Text>
      </Flex>
    </Card>
  );
};
